import { devLogger } from "@certa/common/utils/devLogger.ts";

type Hook<T extends any[], R> = (...args: T) => R;
const isDebugSafeHook = false;

/* Wrapper for hooks to catch any errors and suppress them (typically context based hooks)
 * @deprecated - This is an anti-pattern, to be removed soon
 */
export function useSafeHook<T extends any[], R>(hook: Hook<T, R>): Hook<T, R> {
  return (...args: T): R => {
    try {
      return hook(...args);
    } catch (error) {
      // Suppressing warnings for dev too, to have a clean console
      if (isDebugSafeHook) {
        devLogger.warn(`Error in hook: ${error}`);
      }

      // Returning empty object as a placeholder
      return {} as any;
    }
  };
}
